import { IconButton } from '@mui/material'
import { GridCellModes, GridCellModesModel, GridCellParams } from '@mui/x-data-grid'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import { Dispatch, SetStateAction } from 'react'

interface EditButtonCellProps extends GridCellParams {
  setCellModesModel: Dispatch<SetStateAction<GridCellModesModel>>
}

export function EditButtonCell(props: EditButtonCellProps) {
  const { id, field, value, setCellModesModel } = props

  const handleEditClick = () => {
    setCellModesModel((prevModel) => {
      return {
        ...Object.keys(prevModel).reduce(
          (acc, rowId) => ({
            ...acc,
            [rowId]: Object.keys(prevModel[rowId]).reduce(
              // eslint-disable-next-line sonarjs/no-nested-functions
              (acc2, colField) => ({
                ...acc2,
                [colField]: { mode: GridCellModes.View },
              }),
              {},
            ),
          }),
          {},
        ),
        [id]: {
          ...Object.keys(prevModel[id] || {}).reduce((acc, colField) => ({ ...acc, [colField]: { mode: GridCellModes.View } }), {}),
          [field]: { mode: GridCellModes.Edit },
        },
      }
    })
  }

  return (
    <>
      {value ? (
        value
      ) : (
        <IconButton size="small" onClick={handleEditClick}>
          <AddCircleOutlineOutlinedIcon fontSize="small" htmlColor="primary.main" />
        </IconButton>
      )}
    </>
  )
}
